/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";
// Get list
export function epcQuery(query) {
    return axios({
        url: "/epcData/index",
        method: "get",
        params: query
    });
}
// Export
export function epcExport(query) {
    return axios({
        url: "/epcData/export",
        method: "get",
        params: query
    });
}
// delete
export function epcDelete(data) {
    return axios({
        url: "/admin/epc/epc/delete",
        method: "post",
        data: data
    });
}